
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";
import { CONST_LIST_DEFO_COUNT } from "@/constants/constant";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";
import { Cl_client } from "@/functions/Cl_client";
import { Cl_filemaster } from "@/functions/Cl_filemaster";
import { DtoClientsGetReqImple } from "mediadept-common/src/common/dto/DtoClientsGetReqImple";
import { DtoClientsGetResImple } from "mediadept-common/src/common/dto/DtoClientsGetResImple";
import { DtoFileMastersGetReqImple } from "mediadept-common/src/common/dto/DtoFileMastersGetReqImple";
import { DtoFileMastersGetResImple } from "mediadept-common/src/common/dto/DtoFileMastersGetResImple";

import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import Encoding from "encoding-japanese";
import CallAPI from "@/functions/Cl_api";
import { CONST_OP_ALERT_CONTRACT } from "mediadept-common/src/common/constant/Constants";
import { DtoClientsDeleteReq } from "mediadept-common/src/common/dto/abst/DtoClientsDeleteReq";
import { EntityClient } from "mediadept-common/src/common/entity/EntityClient";
import {
  CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR,
  CONST_RAKURAKU_CUSTOMERCODE_NUMLENGTH,
  CONST_RAKURAKU_EXPORT_HEADER,
  CONST_RAKURAKU_CSV_ITEMCOUNT,
} from "mediadept-common/src/common/constant/Constants";

@Options({
  components: {
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class Uriagesakilist extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoClientsGetResImple();
  //ボタン制御用
  btnDisable = false;
  //検索条件dom
  domIdStart = "";
  domIdEnd = "";
  domClientName = "";

  columns = [
    {
      label: "詳細",
      field: "btnDet",
      width: "10%",
    },
    {
      label: "売上先コード",
      field: "c_client_id",
    },
    {
      label: "売上先名",
      field: "c_client_name",
      width: "300px",
    },
    {
      label: "顧客担当者名",
      field: "c_client_staff_name",
    },
    {
      label: "顧客部署",
      field: "c_client_depart",
    },
    {
      label: "メールアドレス",
      field: "c_client_main_mail",
    },
  ];

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.getlist(1);
  }
  //----------------------
  //基本操作用メソッド
  //----------------------
  /**
   * 一覧データを読み込む
   */
  async getlist(currentPage: number) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementById("panel-search");
    const panel2 = document.getElementById("panel-list");
    panel?.classList.add("enable-loader");
    panel2?.classList.add("enable-loader");

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoClientsGetReqImple();

      //検索条件設定
      // dto.pager.count = CONST_LIST_DEFO_COUNT;
      dto.pager.count = 9999;
      dto.pager.cursor = currentPage;
      if (this.domIdStart != "" && this.domIdStart != null)
        dto.clientId_start = Number(this.domIdStart);
      if (this.domIdEnd != "" && this.domIdEnd != null)
        dto.clientId_end = Number(this.domIdEnd);

      dto.clientName = this.domClientName;

      //API実行
      //-------
      this.delegate = await Cl_client.getList(dto);
      //レスポンス処理
      //-------
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      //エラー発生で一覧を初期化
      this.delegate = new DtoClientsGetResImple();
      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      panel?.classList.remove("enable-loader");
      panel2?.classList.remove("enable-loader");
    }
  }

  async moveDet(id: string) {
    //詳細ページに移動
    this.$router.push("/uriagesakiedit?id=" + id);
  }
  /**
   * ページ更新時の処理
   * @param params
   */
  async onPageChange(params: any) {
    //テーブル更新処理
    await this.getlist(params.currentPage);
  }
  /**
   * ソート変更時の処理
   * @param params
   */
  async onSortChange(params: any) {
    //テーブル更新処理
  }
  /**
   * 画面遷移用
   * @param url
   * @param event
   */
  async goTo(url: string, event?: MouseEvent) {
    Cl_common.goTo(url, this.$router, event);
  }
  /**
   * ファイルをダウンロードする
   */
  async dl() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoFileMastersGetReqImple();
      dto.type = "UriagesakiList";
      dto.fromCode = Number(this.domIdStart);
      dto.toCode = Number(this.domIdEnd);
      dto.name = this.domClientName;

      //API実行
      //-------
      const res = await Cl_filemaster.get(dto);
      Cl_common.logger(res);
      Cl_common.logger(res.url);

      //レスポンス処理
      //-------
      location.href = res.url;
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 楽楽明細にインポートするCSVファイルをダウンロード
   */
  async csvExport() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //API実行
      //-------
      const res = await Cl_client.exportClients();
      Cl_common.logger(res);
      Cl_common.logger(res.url);

      //レスポンス処理
      //-------
      location.href = res.url;
      //window.open(res.url, "_blank");
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * インポート処理の実行
   */
  async execImport() {
    let entityList: EntityClient[] | null;
    // 確認メッセージを閉じる
    const modal: any = this.$refs.Mo_modal_importConf;
    modal.closeModal();
    try {
      // インポート情報を作成
      entityList = await this.createClientEntitys();
      if (entityList == null) {
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();

        Cl_common.logger("インポート情報の作成でエラーが発生しました");
        return;
      }
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
      return;
    }

    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });
    try {
      // インポート処理の実行
      await Cl_client.importClients(entityList);
      // 連携成功後
      this.message4ModalSuccess = "業務システムへの取込が完了しました";
      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }
  /**
   * 業務システムへ取込(CSVインポート)
   */
  async csvImport() {
    // ファイル選択POPUP表示
    const element: any = this.$refs.uploadFile;
    // ファイルの指定を初期化
    element.value = "";
    element.click();
  }
  /**
   * CSV取込
   */
  async confirmImport() {
    // 楽楽明細からダウンロードしたCSVかどうかを確認
    let result = await this.isRakurakuCsvFile();
    if (result) {
      // 形式がOKであれば確認モーダル表示
      const modal: any = this.$refs.Mo_modal_importConf;
      modal.showModal();
      return;
    }
  }
  /**
   * 選択されたファイルが楽楽明細からダウンロードしたCSVファイル形式かどうかを確認する
   */
  async isRakurakuCsvFile() {
    try {
      // インポートファイル
      const element: any = this.$refs.uploadFile;
      const file = element.files[0];
      // ファイルの中身を取得
      const arrayBuffer = await file.arrayBuffer();
      // arrayBufferのバイナリデータを1バイト（8ビット）ごとにアクセスできるUint8Array（符号なし8ビット整数の配列）として扱えるようにする
      const uint8Array = new Uint8Array(arrayBuffer);
      // SJISからUniCodeに変換
      const unicodeString = Encoding.convert(uint8Array, {
        from: "SJIS",
        to: "UNICODE",
        type: "string",
      });
      // 改行区切りで取得
      const lines = unicodeString.split(/\r\n|\n|\r/);
      let rowNumber = 0;
      let entityList: any[] = [];
      let result = true;
      // 1行ずつ処理
      lines.forEach((line) => {
        if (rowNumber == 0) {
          // 先頭の行がヘッダ行かどうかを確認
          if (!this.isHeaderRow(line)) {
            this.message4ModalErrorConf =
              "楽楽明細から出力したCSVファイルを指定してください";
            //モーダル表示
            const modal: any = this.$refs.Mo_modal_errorConf;
            modal.showModal();
            result = false;
          }
        } else {
          // 最終行(空白)は読み込み終了
          if (this.isFinalRow(line)) {
            return;
          }
          // 明細行かどうかを確認
          if (!this.isDetailRow(line)) {
            this.message4ModalErrorConf =
              "楽楽明細から出力したCSVファイルを指定してください";
            //モーダル表示
            const modal: any = this.$refs.Mo_modal_errorConf;
            modal.showModal();
            result = false;
          } else {
            let entity = this.createEntity(line);
            if (entity != null) {
              entityList.push(entity);
            }
          }
        }
        rowNumber++;
      });
      return result;
    } catch (error) {
      console.log("楽楽明細ファイルのチェック処理でエラーが発生しました");
      return false;
    }
  }
  /**
   * 業務システムに取り込む売上先マスタのEntityリストを作成
   */
  async createClientEntitys() {
    try {
      // インポートファイル
      const element: any = this.$refs.uploadFile;
      const file = element.files[0];
      // ファイルの中身を取得
      const arrayBuffer = await file.arrayBuffer();
      // arrayBufferのバイナリデータを1バイト（8ビット）ごとにアクセスできるUint8Array（符号なし8ビット整数の配列）として扱えるようにする
      const uint8Array = new Uint8Array(arrayBuffer);
      // SJISからUniCodeに変換
      const unicodeString = Encoding.convert(uint8Array, {
        from: "SJIS",
        to: "UNICODE",
        type: "string",
      });
      // 改行区切りで取得
      const lines = unicodeString.split(/\r\n|\n|\r/);
      let rowNumber = 0;
      let entityList: any[] = [];
      let result = false;
      // 1行ずつ処理
      lines.forEach((line) => {
        if (rowNumber == 0) {
          // 先頭の行がヘッダ行かどうかを確認
          if (!this.isHeaderRow(line)) {
            return;
          }
        } else {
          // 最終行(空白)は読み込み終了
          if (this.isFinalRow(line)) {
            result = true;
            return;
          }
          // 明細行かどうかを確認
          if (!this.isDetailRow(line)) {
            return;
          } else {
            let entity = this.createEntity(line);
            if (entity != null) {
              entityList.push(entity);
            }
          }
        }
        rowNumber++;
      });
      if (result) {
        return entityList;
      } else {
        return null;
      }
    } catch (error) {
      console.log("売上先マスタのEntityリスト作成でエラーが発生しました");
      return null;
    }
  }
  /**
   * 指定の文字列が楽楽明細からエクスポートしたCSVのヘッダかどうかを確認
   * @param line
   */
  isHeaderRow(line: string) {
    return line == CONST_RAKURAKU_EXPORT_HEADER;
  }
  /**
   * 指定の文字列が楽楽明細からエクスポートしたCSVの明細かどうかを確認
   * @param line
   */
  isDetailRow(line: string) {
    // カンマ区切りにした時の項目の数
    const rakurakuDetailItemCount = CONST_RAKURAKU_CSV_ITEMCOUNT;
    return line.split(",").length == rakurakuDetailItemCount;
  }
  /**
   * 楽楽明細の顧客コード「FK000000」形式かどうかを確認
   * @param str
   */
  isRakurakuCustomerCode(str: string) {
    // return /^FK\d{6}$/.test(str);
    const regex = new RegExp(
      `^${CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR}\\d{${CONST_RAKURAKU_CUSTOMERCODE_NUMLENGTH}}$`
    );
    return regex.test(str);
  }
  /**
   * CSVの明細文字列からEntityを作成する
   * @param line
   */
  createEntity(line: string) {
    let items = line.split(",");
    let entity = new EntityClient();
    // 顧客コード
    let rakurakuCustomerCode = items[0];
    if (!this.isRakurakuCustomerCode(rakurakuCustomerCode)) {
      // 「FK000000」形式でなければNULLを返却（インポート対象外）
      return null;
    }
    // 顧客コード
    entity.c_client_id = Number(
      rakurakuCustomerCode.substring(
        CONST_RAKURAKU_CUSTOMERCODE_FIRSTSTR.length
      )
    );
    // 顧客名
    entity.c_client_name = items[1];
    // 部署名
    entity.c_client_depart = items[2];
    // 担当者名
    entity.c_client_staff_name = items[3];
    // 郵便番号
    entity.c_client_zip = items[5];
    // 住所１
    entity.c_client_address_1 = items[6];
    // 住所２
    entity.c_client_address_2 = items[7];
    // メールアドレス
    entity.c_client_main_mail = items[8];
    // サブメールアドレス
    entity.c_client_sub_mail1 = items[9];
    entity.c_client_sub_mail2 = items[10];
    entity.c_client_sub_mail3 = items[11];

    return entity;
  }
  /**
   * 指定の行が最終行(空白)かどうかを確認
   * @param line
   */
  isFinalRow(line: string) {
    return line.length == 0;
  }
  /**
   * ファイルアップロード処理
   */
  async postFile() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      const element: any = this.$refs.uploadFile;
      const uploadFile = element.files[0];

      if (element.files[0].size > 10000000) {
        this.message4ModalErrorConf =
          "アップロードできるファイルサイズは、10Mまでです";
        //モーダル表示
        const modal: any = this.$refs.Mo_modal_errorConf;
        modal.showModal();
        return;
      }

      if (uploadFile != undefined) {
        //マップ画像保存。
        //------------------
        //要素からファイル情報取得。
        const exix = uploadFile.name.split(".").pop();
        if (exix != "CSV" && exix != "csv") {
          this.message4ModalErrorConf = "アップロードできるのは、CSVのみです";
          //モーダル表示
          const modal: any = this.$refs.Mo_modal_errorConf;
          modal.showModal();
          return;
        }
      }
      // ファイルがCSVであれば取込処理開始
      this.confirmImport();
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
  async closeModal4importConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_importConf;
    modal.closeModal();
  }
}
